import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import {
  getServices as onGetServices,
  postResendEmail as onPostResendEmail,
  getBluejayTeam as onGetBluejayTeam,
  postTestNotification,
  getMsTeamsChannels as onGetMsTeamsChannels,
  getBluejayCommunicationChannelByServiceId
} from "../../store/actions";
import '../../pages/Service/services.scss';

import { Badge, Card, CardBody, Spinner, Table, UncontrolledTooltip,PopoverBody, Popover } from "reactstrap";

import OnCallModal from "./OnCallModal";
import OnEditModal from "./OnEditModal";
import { getLocalDateTime } from "../../helpers/component_helpers";
import moment from "moment-timezone";

const Services = props => {

  const [modal1, setModal1] = useState(false);

  const [modal, setModal] = useState(false);

  const [isLoadingMap, setIsLoadingMap] = useState({});

  const [serviceId, setServiceId] = useState(null);

  const [onCallService, setOnCallService] = useState();

  const organizationDetails = useSelector(state => state.Organization.organization || {});

  const [teams, setTeams] = useState([])
  const[popoverOpen1,setPopoverOpen1] = useState({});
  const [iconPopoverOpen, setIconPopoverOpen] = useState([]);
  const [iconPopoverText, setIconPopoverText] = useState('');
  const dispatch = useDispatch();

  const { services } = useSelector(state => ({
    services: state.Service.services
  }));

  const handleMouseOverEndpoint = (key) => {
    toggleTooltip(key, true);
  };
  const handleMouseLeaveEndpoint = (key) => {
    toggleTooltip(key, false);
  };

  const toggle = () => {
    if (modal) {
      setServiceId(null);
      setModal(false);
    } else {
      setModal(true);
    }
  }
  const toggleTooltip = (key, isOpen) => {
    setPopoverOpen1(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const onEditService = (serviceIdx, index) => {
    setServiceId(serviceIdx);
    dispatch(getBluejayCommunicationChannelByServiceId(serviceIdx))
    toggle();
  }

  const testNotification = (serviceIdx, index) => {
    let payload = {
      'application_service_id': serviceIdx,
    }
    dispatch(postTestNotification(payload));
  }

  useEffect(() => {
    dispatch(onGetServices());
  }, [onGetServices]);

  const toggleViewModal = serviceId => {
    setOnCallService(serviceId);
    setModal1(!modal1);
  };

  const handleResendEmailConfirmation = async (application_service_id) => {
    let payload = {
      'application_service_id': application_service_id,
    }
    setIsLoadingMap(prevState => ({
      ...prevState,
      [application_service_id]: true,
    }));

    await dispatch(onPostResendEmail(payload));

    setTimeout(() => {
      setIsLoadingMap(prevState => ({
        ...prevState,
        [application_service_id]: false,
      }));
    }, 3000);
  }

  function getCurrentTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  function getMaintenanceState(maintenanceEnd) {
    let localTimeZone = getCurrentTimezone();
    const currentTime = moment().tz(localTimeZone);

    const orgMaintenanceEndMoment = moment(organizationDetails.maintenance_window_end).tz(localTimeZone);
    if(currentTime.isBefore(orgMaintenanceEndMoment)) {
      return true;
    }

    const maintenanceEndMoment = moment(maintenanceEnd).tz(localTimeZone);
    return currentTime.isBefore(maintenanceEndMoment);
  }

  function handleMouseEnterIcon(index, text) {
    const arr = [...iconPopoverOpen];
    arr[index] = true;
    setIconPopoverOpen(arr);
    setIconPopoverText(text);
  }

  function handleMouseLeaveIcon(index) {
    const arr = [...iconPopoverOpen];
    arr[index] = false;
    setIconPopoverOpen(arr);
    setIconPopoverText('');
  }

  useEffect(() => {
    dispatch(onGetBluejayTeam());
  }, [onGetBluejayTeam])

  useEffect(() => {
    dispatch(onGetMsTeamsChannels());
  }, [onGetMsTeamsChannels])

  const { bluejayTeams } = useSelector(state => ({
    bluejayTeams: state.Organization.bluejay_teams || []
  }))

  useEffect(() => {
    setTeams(bluejayTeams)
  }, [bluejayTeams])

  const domain = window.location.hostname;

  const headers = ['Name', 'Service Email', 'Slack', 'On-Call Policy', 'Team', 'Updated At', 'Action']//, 'View Details']

  if (domain === 'msteamtestaccount.temperstack.com' || domain == '10xengg.myapp.com' || domain.endsWith("temperstack.dev")) {
    headers.splice(2, 0, 'MS Teams');
  }


  return (
    <React.Fragment>
      <OnCallModal isOpen={modal1} serviceId={onCallService} toggle={toggleViewModal} />
      <OnEditModal isOpen={modal} serviceId={serviceId} toggle={toggle} />
      
          <div className="table-card">
            <Table className="table-purple" responsive>
              <thead className="table-light" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                <tr>
                  {headers.map((header, index) => (
                    <th key={index}>
                      <div className="mb-2 text-white">
                        {header}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="table-dark" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                {services.map((service, index) => {
                  const isLoading = isLoadingMap[service.id] || false;
                  return (
                    <Fragment key={index}>
                      <tr>
                        <td>
                          <Link to={`/temperstack-notifications/${service?.id}`}
                            className="link-primary">
                            {service?.name}
                          </Link>
                        </td>
                        <td>
                          <div className="d-flex gap-2 align-items-center justify-content-center">
                            {service?.email_verified ? (
                              <div>
                                <i className="mdi mdi-check-circle text-success" id={`emailVerifiedTooltip-${index}`} />
                                <UncontrolledTooltip placement="top" target={`emailVerifiedTooltip-${index}`}>
                                  Email Verified
                                </UncontrolledTooltip>
                              </div>
                            ) : (
                              <div>
                                <i className="mdi mdi-close-circle text-danger" id={`emailNotVerifiedTooltip-${index}`} />
                                <UncontrolledTooltip placement="top" target={`emailNotVerifiedTooltip-${index}`}>
                                  Email Not Verified
                                </UncontrolledTooltip>
                              </div>
                            )}
                            <div
                              id={`email_tooltip_${service.id}`}
                              className="email-truncate text-white"
                              style={{
                                display: 'inline-block',
                                maxWidth: '200px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                              onMouseEnter={() => handleMouseOverEndpoint(service.id)}
                              onMouseLeave={() => handleMouseLeaveEndpoint(service.id)}
                            >
                              {service?.email_id.length > 80 ? service?.email_id.substring(0, 80) + "..." : service?.email_id}
                            </div>
                            <Popover
                              placement="top"
                              isOpen={popoverOpen1[service.id] || false}
                              target={`email_tooltip_${service.id}`}
                              toggle={() => toggleTooltip(service.id, !popoverOpen1[service.id])}
                            >
                              <PopoverBody>{service?.email_id}</PopoverBody>
                            </Popover>
                            {!isLoading && !service?.email_verified && (
                              <>
                                <i className="mdi mdi-refresh font-size-18" id={`resend-${index}`} onClick={(e) => {
                                  e.preventDefault();
                                  handleResendEmailConfirmation(service?.id);
                                }} />
                                <UncontrolledTooltip placement="top" target={`resend-${index}`}>
                                  Resend Verification Email
                                </UncontrolledTooltip>
                              </>
                            )}
                            {isLoading && <Spinner id={`spinner-${service.id}`} color="primary" size="sm" />}
                          </div>
                        </td>
                        {(domain === 'msteamtestaccount.temperstack.com' || domain == '10xengg.myapp.com' || domain.endsWith("temperstack.dev")) ? (
                          <td>
                            <strong>{service?.ms_team_channel?.name}</strong><br />
                            {service?.ms_team_channel_name}
                          </td>
                        ) : null}
                        <td className="text-white">
                          {service?.slack_channel_name}
                        </td>
                        <td>
                          <Link to={`/oncall-policies/${service?.bluejay_oncall_policy?.id}`}
                            className="link-primary">
                            {service?.bluejay_oncall_policy?.name}
                          </Link>
                        </td>
                        <td className="text-white">
                          {service?.bluejay_team?.name}
                        </td>
                        <td className="text-white">
                          {service.updated_at ? getLocalDateTime(service?.updated_at) : '-'}
                        </td>
                        <td className="text-center">
                          <div className="position-relative">
                            <Link
                              className="text-success"
                              onClick={() => {
                                onEditService(service.id, index);
                              }}>
                              <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${index}`} />
                              <UncontrolledTooltip className="service-tooltip-component" placement="top" target={`edittooltip-${index}`}>
                                Edit
                              </UncontrolledTooltip>
                            </Link>
                            {getMaintenanceState(service?.maintenance_window_end) ?
                              <div id={`on_maintenance_${index}`}
                                   onMouseEnter={() => handleMouseEnterIcon(index, `Under maintenance`)}
                                   onMouseLeave={() => handleMouseLeaveIcon(index)}
                                   style={{display: 'inline-block'}}>
                                <i className="mdi mdi-alert blinking-icon"/>
                                <Popover isOpen={iconPopoverOpen[index] || false}
                                         target={`on_maintenance_${index}`}
                                         placement="top">
                                  <PopoverBody>{iconPopoverText}</PopoverBody>
                                </Popover>
                              </div>
                              : <Link
                                className="text-danger"
                                onClick={() => {
                                  testNotification(service.id, index);
                                }}>
                                <i className="mdi mdi-bell font-size-18" id={`testNotification-${index}`}/>
                                <UncontrolledTooltip className="service-tooltip-component" placement="top" target={`testNotification-${index}`}>
                                  Test Notification
                                </UncontrolledTooltip>
                              </Link>
                            }
                          </div>
                        </td>
                      </tr>
                    </Fragment>
                  );
                })}
              </tbody>
            </Table>
          </div>
    </React.Fragment>
  );
};

Services.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(Services);
